import { useEffect, useState, type FormEvent } from "react";
import { useContextoApp } from "@/app/contexto";
import { useApiResource } from "@/hooks/useApiResource";
import { useAsyncAction } from "@/hooks/useAsyncAction";
import { api, type Fideicomiso } from "@/lib/api";
import { aPayload, formDesde, validarFideicomiso, type FormFideicomiso } from "@/lib/fideicomisos";

/** Lógica de Configuración → Fideicomiso (sin JSX). */
export function useConfigFideicomisoTab() {
  const { fid } = useContextoApp();
  const ruta = `/api/fideicomisos/${fid}`;
  const recurso = useApiResource<Fideicomiso>(ruta);
  const [form, setForm] = useState<FormFideicomiso | null>(null);
  const [intentado, setIntentado] = useState(false);
  const [guardado, setGuardado] = useState(false);
  const accion = useAsyncAction((cuerpo: ReturnType<typeof aPayload>) => api.patch<Fideicomiso>(ruta, cuerpo));

  useEffect(() => {
    if (recurso.data) setForm(formDesde(recurso.data));
  }, [recurso.data]);

  const errores = form ? validarFideicomiso(form) : {};

  const cambiar = (campo: keyof FormFideicomiso, valor: string) => {
    setForm((f) => (f ? { ...f, [campo]: valor } : f));
    setGuardado(false);
  };

  const guardar = async (e: FormEvent) => {
    e.preventDefault();
    setIntentado(true);
    if (!form || Object.keys(errores).length > 0) return;
    const actualizado = await accion.run(aPayload(form));
    if (actualizado) {
      setForm(formDesde(actualizado));
      setIntentado(false);
      setGuardado(true);
    }
  };

  return {
    cargando: form === null && recurso.loading,
    errorCarga: form === null ? (recurso.error?.message ?? null) : null,
    reintentar: recurso.recargar,
    form,
    cambiar,
    errores: intentado ? errores : {},
    guardar,
    guardando: accion.loading,
    error: accion.error,
    guardado,
  };
}
